import { LGraphNode, LiteGraph } from "litegraph.js";

/**
 * ClockNode
 * ---------
 * Outputs current time as separate hour, minute, second values.
 * Also outputs a formatted time string. Build a live typographic clock.
 */
export class ClockNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Clock";

    this.properties = {
      format24: true,
    };

    this.addOutput("Hours", "number");
    this.addOutput("Minutes", "number");
    this.addOutput("Seconds", "number");
    this.addOutput("Time", "string");

    this.addWidget("toggle", "24h", true, (val) => {
      this.properties.format24 = val;
    });

    this.size = [160, 100];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onDrawForeground(ctx) {
    const now = new Date();
    const h = this.properties.format24 ? now.getHours() : (now.getHours() % 12 || 12);
    const m = String(now.getMinutes()).padStart(2, "0");
    const s = String(now.getSeconds()).padStart(2, "0");
    const timeStr = `${h}:${m}:${s}`;

    ctx.fillStyle = "rgba(255,255,255,0.6)";
    ctx.font = "bold 18px monospace";
    ctx.textAlign = "center";
    ctx.fillText(timeStr, this.size[0] / 2, this.size[1] - 14);
    ctx.textAlign = "left";
  }

  onExecute() {
    const now = new Date();
    const h = this.properties.format24 ? now.getHours() : (now.getHours() % 12 || 12);
    this.setOutputData(0, h);
    this.setOutputData(1, now.getMinutes());
    this.setOutputData(2, now.getSeconds());

    const timeStr = `${h}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;
    this.setOutputData(3, timeStr);
  }
}

LiteGraph.registerNodeType("generators/Clock", ClockNode);
